module.exports = __webpack_public_path__ + "img/union.2be8b045.png";